import React from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';

import { Link } from '@zillow/zrs-comet';

import PropertiesActions from 'app/shared/actions/PropertiesActions';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import NotificationConstants from 'app/shared/constants/NotificationConstants';
import PostingActions from 'app/shared/actions/PostingActions';
import { StyledRenewContainer, StyledBlockText } from './StyledComponents';

const RenewListing = (props) => {
    const {
        dispatch,
        listing,
        propertyId,
        validateRequiredFields,
        updateStatusMessage,
        setHasErrors,
        setSuccessfulRenewalData,
        setFailedRenewalData,
    } = props;
    const { aliasEncoded, paidInclusion } = listing;
    const { isEnabled: isListingInNucleusMarket, isPaymentRequired } = paidInclusion || {};
    const isFreeListing = !isPaymentRequired;

    const extendListing = () => {
        if (validateRequiredFields(true)) {
            setHasErrors(true);
        } else {
            setHasErrors(false);
        }

        updateStatusMessage('Renewing listing...');

        return dispatch(PostingActions.property.activate(propertyId, true))
            .then((result) => {
                const { success, response } = result;
                if (success === true) {
                    const { expirationDate } = response;
                    const formattedExpirationDate = format(new Date(expirationDate), 'MMM D, YYYY');

                    setSuccessfulRenewalData(formattedExpirationDate);
                    dispatch(PropertiesActions.updateCurrentProperty({ expirationDate: formattedExpirationDate }));
                    updateStatusMessage('Listing renewed!', NotificationConstants.SUCCESS);

                    if (isListingInNucleusMarket === false) {
                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.EXTEND_LISTING_NON_NUCLEUS_MARKET,
                            { label: aliasEncoded }
                        ));
                    } else if (isListingInNucleusMarket && isFreeListing) {
                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.EXTEND_LISTING_FREE_NUCLEUS_MARKET,
                            { label: aliasEncoded }
                        ));
                    }
                }
            })
            .catch((errorRMWModel) => {
                setFailedRenewalData(errorRMWModel.message);
                global.TEMPORARY_global_logger.warn('HPPP_ACTIVATION_ERROR: %s', errorRMWModel);
            });
    };

    return (
        <StyledRenewContainer className="RenewListing">
            <StyledBlockText>
                Still looking for a renter?
            </StyledBlockText>
            <Link
                type="primary"
                onClick={extendListing}
                style={{ marginLeft: '8px' }}
            >
                <StyledBlockText fontColor="brand">
                    Renew listing for 30 days
                </StyledBlockText>
            </Link>
        </StyledRenewContainer>
    );
};

export { RenewListing };
export default connect()(RenewListing);
